import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { produce, Draft } from "immer";
import {
  GetCityApi,
  GetMasterApi,
  getProfileApi,
  GetStateApi,
} from "../../api/services";

interface State {
  stateData: StateType[];
  cityData: CityType[];
}
export const getStateReducer = createAsyncThunk<State["stateData"]>(
  "profile/getStateReducer",
  async (data, thunkAPI) => {
    try {
      const result = await GetStateApi();
      if (result?.success) {
        return result?.states as State["stateData"];
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getCiyReducer = createAsyncThunk<
  State["cityData"],
  { state_id: number }
>("profile/getCiyReducer", async (data, thunkAPI) => {
  try {
    const result = await GetCityApi(data);
    if (result?.success) {
      return result?.cities as State["cityData"];
    } else {
      throw new Error("Failed to fetch data");
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

const initialState: State = {
  stateData: [],
  cityData: [],
};

const ProfileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {

    builder.addCase(
      getStateReducer.pending,
      (state, action: PayloadAction<State["stateData"] | undefined>) => {
        state.stateData = [];
      }
    );
    builder.addCase(
      getStateReducer.fulfilled,
      (state, action: PayloadAction<State["stateData"] | undefined>) => {
        state.stateData = action.payload ?? [];
      }
    );
    builder.addCase(getStateReducer.rejected, (state) => {
      state.stateData = [];
    });
    builder.addCase(getCiyReducer.pending, (state) => {
      state.cityData = [];
    });
    builder.addCase(
      getCiyReducer.fulfilled,
      (state, action: PayloadAction<State["cityData"] | undefined>) => {
        state.cityData = action.payload ?? [];
      }
    );
    builder.addCase(getCiyReducer.rejected, (state) => {
      state.cityData = [];
    });
  },
});

export default ProfileSlice;
